import { Token } from "@/utils/types";
import { JSX } from "react";

export interface DataItem {
  token: Token;
  value: number;
}

export interface TokenCardProps {
  icon: JSX.Element;
  title: string;
  data: DataItem[];
  delay: number;
  isServer?: boolean;
}

export function TokenCard({ icon, title, data, delay, isServer = false }: TokenCardProps) {
  const card = (
    <div className="stat-card-wrap">
      <div className="stat-card-head">
        {icon}
        {title}
      </div>
      {data.map((item, i) => {
        const symbolName =
          item.token.name === "native"
            ? "XLM"
            : `${item.token.name.substring(0, 8)}...${item.token.name.substring(item.token.name.length - 3)}`;
        return (
          <div key={item.token.id} className="stat-row">
            <span className="stat-rank">#{i + 1}</span>
            <span className="stat-pair">{symbolName}</span>
            <span className="val-muted">${item.value.toLocaleString().split(".")[0]}</span>
          </div>
        );
      })}
    </div>
  );

  return isServer ? card : (
    <div
      className="transform-gpu transition-transform hover:scale-[1.02] anim-fadeSlideInUp-300ms"
      style={{ animationDelay: `${String(delay)}s` }}
    >
      {card}
    </div>
  );
}
